import React from 'react';

import { getJoinedFileTypes } from 'utils/fileUtils';

type Props = {
  fileTypes: Array<string>;
};

export default function BaseDraggerContent(props: Props) {
  const { fileTypes } = props;
  const joinedFileTypes = getJoinedFileTypes(fileTypes);

  return (
    <>
      <p className="ant-upload-drag-icon">
        <span className="icon icon-inbox" />
      </p>

      <div className="text-wrapper">
        <p className="ant-upload-text">Drag and drop to upload</p>
        <p className="ant-upload-hint">
          Acceptable file types: {joinedFileTypes}
        </p>
      </div>
    </>
  );
}
